<!--- Formulario PCReprocessed ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-
Eventos escuchados por el componente:
-----------------------

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div>
    <div class="content-gestion-traspasos">
      <div class="content-gestion-traspasos__cabecera padding-horizontal padding-vertical-half">
        <div>
          <!--
          <img
            src="@/static/icons/ic_print.svg"
            :class="{ 'disabled': !print}"
            @click="PrintLabel(palePrint)"
          >
          -->
          <div v-if="mainData != null && mainData.InfoNuevoPale == null">
            <span class="content-gestion-traspasos__cabecera--strong">
              {{
                paletSelected != null
                  ? paletSelected.UnidadContenedora.NumeroSerie
                  : $t('common.logisticsUnit')
              }}
            </span>
            <div
              v-if="paletSelected != null"
            >
              <span v-if="paletSelected.UnidadContenedora.InfoEnvase != null">{{ paletSelected.UnidadContenedora.InfoEnvase.Nombre }} </span>
              <span v-else> {{ GetContainerFromPale(paletSelected.UnidadContenedora) }} </span>
            </div>
          </div>
          <div
            v-else
            class="content-gestion-traspasos__cabecera--strong"
          >
            {{ $t('commercialization.common.newPallet') }}
          </div>
        </div>
        <div>
          <span class="content-gestion-traspasos__cabecera--ligh">
            {{ $t('commercialization.picking.palletizing.labels.currentPackages') }}
          </span>
          <span class="content-gestion-traspasos__cabecera--strong">
            <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
            {{ paletSelected != null ? paletSelected.CajasReservadas : 0 }}
          </span>
        </div>
        <div>
          <span class="content-gestion-traspasos__cabecera--ligh">
            {{ $t('commercialization.picking.palletizing.labels.packagesToTransfer') }}
          </span>
          <span class="content-gestion-traspasos__cabecera--strong">{{ sumaTotalCajasReprocesar }}</span>
        </div>
        <div class="content-gestion-traspasos__cabecera--buttons">
          <img
            alt="iconQr"
            src="@/static/icons/ic_qr.svg"
            @click="OpenReadBarCode"
          >
        </div>
      </div>

      <div
        v-if="mainData != null && mainData.Mercancia.length > 0 "
        class="content-gestion-traspasos__list"
      >
        <div
          v-for="(option, i) in mainData.Mercancia"
          :key="i"
          class="content-gestion-traspasos__item padding-horizontal padding-vertical-half"
        >
          <div>
            <span class="content-gestion-traspasos__item--strong">
              {{ option.NumeroSerie }}
            </span>
            <!-- {{ option != null && option.PuntoPaletizadoConfeccion != undefined ? option.PuntoPaletizadoConfeccion.Codigo : "Sin punto de paletizado" }} -->
            <span
              v-if="option.InfoEnvase != null"
              class="content-gestion-traspasos__item--ligh"
            >{{ option.InfoEnvase.Nombre }} </span>
            <span
              v-else
              class="content-gestion-traspasos__item--ligh"
            > {{ GetContainerFromPale(option) }} </span>
          </div>

          <div>
            <span class="content-gestion-traspasos__item--ligh">
              {{ $t('commercialization.picking.palletizing.labels.availableBoxes') }}
            </span>
            <span class="content-gestion-traspasos__item--strong">
              {{ option.CajasDisponibles }}
            </span>
          </div>

          <div class="content-gestion-traspasos__item--counter">
            <span class="content-gestion-traspasos__item--ligh">
              {{ $t('commercialization.picking.palletizing.labels.boxesToTransfer') }}
            </span>
            <div>
              <UCInputIncrement
                :val="option.CajasTraspasar"
                :max-valor="option.CajasDisponibles"
                @value="ChangeValueArray($event, i)"
              />
            </div>
          </div>

          <div>
            <img
              alt="iconDelete"
              src="@/static/icons/ic_delete.svg"
              @click="DeletePaleSelection(option)"
            >
            <img
              alt="iconPopup"
              src="@/static/icons/ic_options_gray.svg"
              @click="OpenPopupPaleData(option)"
            >
          </div>
        </div>
      </div>

      <f7-block class="content-paletizado-buttons padding">
        <f7-row>
          <f7-col class="display-flex justify-content-flex-start">
            <f7-button
              v-if="selectedEditPale == null
                && (mainData != null && mainData.Base == null && mainData.InfoNuevoPale == null)"
              color="orange"
              fill
              class="color-letra"
              @click="PressNewPalet()"
            >
              {{ $t('commercialization.common.newPallet') }}
            </f7-button>
            <f7-button
              fill
              class="margin-left color-tipo-envasado"
              @click="PressTypePackagingReprocessed()"
            >
              {{ $t('commercialization.picking.palletizing.labels.packagingType') }}
            </f7-button>
          </f7-col>

          <f7-col class="display-flex justify-content-flex-end">
            <f7-button
              color="gray"
              @click="PressCancel"
            >
              {{ $t('common.cancel') }}
            </f7-button>
            <f7-button
              class="margin-left"
              :class="{ disabled: !btnOkEnable }"
              fill
              color="green"
              @click="PressConfirmar"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
      <!-- reprocesado  Main Data: <pre>{{ mainData }} </pre> -->
    </div>

    <!-- pop up con el formulario para la zona de reprocesados -->
    <PCPopupTypePackagingReprocessed
      ref="PCPopupTypePackagingReprocessed"
      :order-line="selectedOrderLine"
      :disable-pale-type="!reprocessedWithNewPale && mainData?.Base != null"
      @confirm="ConfirmTypePackagingReprocessed"
    />
    <!-- popup mostrar datos despues del escaneo de pale -->
    <PCPopupScanData
      ref="PCPopupScanData"
      @confirm="ConfirmScanData"
    />

    <!-- popup mostrar datos especificos de cada palé -->
    <PCPopupPaleData
      ref="PCPopupPaleData"
    />
    <UCCodeScanner
      ref="UCCodeScanner"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      :auto-open-camera="true"
      @code-reading="BarCodeReadingEvent"
      @codigo-barras="BarCodeReadingEvent"
      @numero-serie="NumeroSerieReadingEvent"
    />

    <UCConfirmation ref="UCConfirmationReprocessed" />
  </div>
</template>

<script>
import UCInputIncrement from '@/components/common/UCInputIncrement.vue';
import { LogDetails as Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { ComponentState } from '@/js/common/enum';
import { TipoMovimientoPicking } from '@/js/services/traceability/enumeradosTA';
import PCPopupTypePackagingReprocessed from '@/components/production/commercialization/picking/PCPopupTypePackagingReprocessed.vue';
import PCPopupScanData from '@/components/production/commercialization/picking/PCPopupScanData.vue';
import PCPopupPaleData from '@/components/production/commercialization/picking/PCPopupPaleData.vue';
import { useParamRef } from '@erpagroapp/params';
import {
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { sleep } from '@/js/utils/sleep';

/** @import {
 * InfoNuevoArticuloNumeroSerie,
 * MercanciaAReprocesar,
 * } from '@erpagroapp/types' */

export default {

  name: 'PCReprocessed',
  components: {
    UCInputIncrement,
    UCCodeScanner,
    UCConfirmation,
    PCPopupTypePackagingReprocessed,
    PCPopupScanData,
    PCPopupPaleData,
  },
  props: {
    conPedido: { type: Boolean, default: true },
    selectedEditPale: { type: Object, default: null },
    selectedOrderLine: {
      type: Object,
      default: null,
    },
  },

  emits: [
    'stateChange',
    'confirmation',
    'cancellation',
  ],

  data() {
    return {
      paletSelected: null, // palet seleccionado
      mainData: null,
      sumaTotalCajasReprocesar: 0,
      manageReservation: false, // se ha pulsado el btn de gestionar reserva
      reprocessedWithNewPale: false, // Indica si el reprocesado se realizara con nuevo palé como base.
      mantenerReservaPaleOrigenTraspasoMovilidad: useParamRef('MantenerReservaPaleOrigenTraspasoMovilidad'),
      replanificarCantidadPaleTraspasadoOReprocesado: useParamRef('ReplanificarCantidadPaleTraspasadoOReprocesado'),
    };
  },
  computed: {
    componentState() {
      return this.mainData
        && (
          (this.mainData.Base && !this.selectedEditPale)
          || (this.mainData.Mercancia && this.mainData.Mercancia.length > 0)
          || (this.mainData.InfoNuevoPale)
          || (this.mainData.Base && this.selectedEditPale && this.mainData.Mercancia && this.mainData.Mercancia.length > 0))
        ? ComponentState.EDIT : ComponentState.INITIAL;
    },
    btnOkEnable() {
      return !!((this.mainData
        && this.mainData.Base
        && this.mainData.Mercancia
        && this.mainData.Mercancia.length > 0)
        && this.mainData.ConfeccionReprocesado
        && this.sumaTotalCajasReprocesar > 0)
        || (this.mainData
          && this.mainData.Mercancia
          && this.mainData.InfoNuevoPale
          && this.mainData.Mercancia.length > 0
          && this.mainData.ConfeccionReprocesado
          && this.sumaTotalCajasReprocesar > 0);
    },
    print() {
      return (this.paletSelected != null);
    },
  },
  watch: {
    print(val) {
      if (val) {
        Log(this, 'PCTransfer->watch->selectedEditPale');
        this.palePrint = this.paletSelected;
      }
    },
    selectedEditPale(val) {
      // this.editPale = val;
      if (val != null) {
        Log(this, 'PCReprocessed->watch->selectedEditPale');
        this.SelectedEditPaleRecibed(val);
      }
    },
    componentState(val) {
      this.$emit('stateChange', val);
    },
  },

  mounted() {
    Log(this, 'PCReprocessed->mounted');
    this.StartComponent();
  },

  methods: {
    /**
     * @public
     * @returns {void}
     */
    StartComponent() {
      Log(this, this.StartComponent.name);
      // this.componentState = ComponentState.INITIAL;
      this.mainData = {
        TipoMovimiento: TipoMovimientoPicking.REPROCESADO,
        Base: null,
        Mercancia: [],
        ConfeccionReprocesado: null,
        InfoNuevoPale: null,
        MercanciaAReprocesar: [],
      };
    },

    /**
     * @public
     * @returns {void}
     */
    ResetComponent() {
      this.mainData = {
        TipoMovimiento: TipoMovimientoPicking.REPROCESADO,
        Base: null,
        Mercancia: [],
        ConfeccionReprocesado: null,
        InfoNuevoPale: null,
        MercanciaAReprocesar: [],
      };
      this.paletSelected = null;
      this.sumaTotalCajasReprocesar = 0;
      this.reprocessedWithNewPale = false;
    },
    ChangeValueArray(val, pos) {
      Log(this, this.ChangeValueArray.name);
      this.mainData.Mercancia[pos].CajasTraspasar = val;
      this.CalculateTotalBoxesTransfer();
    },
    PressConfirmar() {
      Log(this, this.PressConfirmar.name);

      this.$refs.UCConfirmationReprocessed.create(
        this.$t('commercialization.picking.palletizing.reprocessed.confirm.title'),
        this.$t('commercialization.picking.palletizing.reprocessed.confirm.text'),
        this.Confirmar,
      );
      this.$refs.UCConfirmationReprocessed.show();
    },
    async Confirmar() {
      Log(this, this.Confirmar.name);
      this.CalcularEstructuraMercanciaReprocesar(); // TODO Cambiar nombre genera la mercancia y cambia las cantidades
      await sleep(200);
      this.$emit('confirmation', this.mainData);
      this.ResetComponent();
    },
    CalcularEstructuraMercanciaReprocesar() {
      Log(this, this.CalcularEstructuraMercanciaReprocesar.name);
      this.mainData.MercanciaAReprocesar = [];
      this.mainData.Mercancia.forEach((element) => {
        /** @type {MercanciaAReprocesar} */
        const mercanciaReprocesar = {
          IdPartida: element.Existencias.find((e) => e.Articulo.TipoArticulo === 'Producto').Partida.Id,
          IdUnidadLogistica: element.Id,
          NumeroEnvases: element.CajasTraspasar,
          LineaPedidoVentaOrigen: element.LineaPedidoVentaOrigen,
        };
        this.mainData.MercanciaAReprocesar.push(mercanciaReprocesar);
      });
      if (this.mainData.Base === null) {
        this.mainData.Base = {
          NumeroSerie: 'Nuevo Palé',
        };
      }
      this.mainData.Base.CajasTraspasar = this.mainData.ConfeccionReprocesado.EnvasesPorPale;
    },
    PressNewPalet() {
      Log(this, this.PressNewPalet.name);
      this.reprocessedWithNewPale = true;
      this.mainData.InfoNuevoPale = {
        Articulo: {
          Id: 0,
          Nombre: 'Nuevo Palé',
        },
      };
      this.$refs.PCPopupTypePackagingReprocessed.Show();
    },
    PressTypePackagingReprocessed() {
      this.$refs.PCPopupTypePackagingReprocessed.Show();
    },
    CalculateTotalBoxesTransfer() {
      Log(this, this.CalculateTotalBoxesTransfer.name);
      this.sumaTotalCajasReprocesar = 0;
      for (let i = 0; i < this.mainData.Mercancia.length; i += 1) {
        const element = this.mainData.Mercancia[i];
        const numCajas = Number.parseInt(element.CajasTraspasar, 10);
        this.sumaTotalCajasReprocesar += numCajas;
      }
      if (this.mainData.Base !== null) {
        this.mainData.Base.CajasTraspasar = this.sumaTotalCajasReprocesar;
      }
    },
    SelectedEditPaleRecibed(value) {
      Log(this, this.SelectedEditPaleRecibed.name);
      this.paletSelected = value;
      this.mainData.Base = this.paletSelected;
    },
    PressCancel() {
      Log(this, this.PressCancel.name);
      this.$emit('cancellation');
      this.manageReservation = false;
      this.ResetComponent();
    },
    InitInputMaxValue() {
      Log(this, this.InitInputMaxValue.name);
      for (let index = 0; index < this.mainData.Mercancia.length; index += 1) {
        this.mainData.Mercancia[index].CajasTraspasar = this.mainData.Mercancia[index].CajasDisponibles;
      }
    },
    OpenReadBarCode() {
      Log(this, this.OpenReadBarCode.name);
      this.$refs.UCCodeScanner.Open();
    },
    OpenPopupPaleData(value) {
      this.$refs.PCPopupPaleData.Show(value);
    },
    async BarCodeReadingEvent(code) {
      Log(this, this.BarCodeReadingEvent.name);
      let paleLeido = null;
      HiDialog.Preloader(true, this.$t('codeScanner.info.validatingBarcode'));
      const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false, true);
      HiDialog.Preloader(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        if (paleLeido.Existencias.length === 0) {
          HiNotification.Alert(this.$t('codeScanner.info.serialNumberNotInStock'), this.$t('common.error'));
          return;
        }
        this.$refs.PCPopupScanData.Show(paleLeido);
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      }
    },

    async NumeroSerieReadingEvent(code) {
      Log(this, this.NumeroSerieReadingEvent.name);
      let paleLeido = null;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      const cancellationText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, true, false);
      PreloaderGH(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        if (paleLeido.Existencias.length === 0) {
          HiNotification.Alert(this.$t('codeScanner.info.serialNumberNotInStock'), this.$t('common.error'));
          return;
        }
        this.$refs.PCPopupScanData.Show(paleLeido);
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      }
    },
    async ProcessPaleRead(newPaleRead) {
      Log(this, this.ProcessPaleRead.name);
      const tempAcumExistenciaProductos = newPaleRead.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Producto'); // TODO
      const tempAcumExitenciasEnvases = newPaleRead.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase'); // TODO
      newPaleRead.InfoProducto = tempAcumExistenciaProductos[0].Articulo;
      newPaleRead.InfoEnvase = tempAcumExitenciasEnvases[0].Articulo;
      newPaleRead.CajasTraspasar = 0;
      // A - Añadir como Base
      if (this.mainData.Base === null && this.mainData.InfoNuevoPale === null) {
        const allowUsePaleInBase = await this.ValidateUsePaleInBase(newPaleRead);
        if (allowUsePaleInBase) {
          newPaleRead.InfoEnvase.Nombre = tempAcumExistenciaProductos.length === 1 ? newPaleRead.InfoEnvase.Nombre : `${newPaleRead.InfoEnvase.Nombre} (+)`;
          newPaleRead.CajasDisponibles = tempAcumExitenciasEnvases.reduce((accumulator, object) => accumulator + object.Cantidad, 0);
          this.mainData.Base = newPaleRead;
          this.paletSelected = {
            UnidadContenedora: newPaleRead,
            CajasReservadas: newPaleRead.CajasDisponibles,
          };
          return; // Se añade solo en la base
        }
        return;
      }
      // B - Añadir como Mercancía.
      const allowUsePaleInMerchandise = await this.ValidateUsePaleInMerchandise(newPaleRead);
      if (allowUsePaleInMerchandise) {
        if (tempAcumExistenciaProductos.length > 1) {
          tempAcumExistenciaProductos.forEach((acumProducto) => {
            const acumEnvase = { ...tempAcumExitenciasEnvases.find((e) => e.Partida.Id === acumProducto.Partida.Id) };
            const linePaleSimulated = { ...newPaleRead };
            linePaleSimulated.Existencias = [];
            linePaleSimulated.Existencias.push({ ...acumProducto });
            linePaleSimulated.Existencias.push({ ...acumEnvase });
            linePaleSimulated.CajasDisponibles = acumEnvase.Cantidad;
            this.mainData.Mercancia.push({ ...linePaleSimulated });
          });
        } else {
          newPaleRead.CajasDisponibles = tempAcumExitenciasEnvases.reduce((accumulator, object) => accumulator + object.Cantidad, 0);
          this.mainData.Mercancia.push(newPaleRead);
        }

        this.mainData.LineaPedidoVentaOrigen = newPaleRead.LineaPedidoVentaOrigen ?? null;

        // this.EmitEventEstado();
        this.CalculateTotalBoxesTransfer();
      }
    },
    async ValidateUsePaleInBase(newPaleRead) {
      Log(this, this.ValidateUsePaleInBase.name);
      // 4.1.1. La unidad logística debe estar reservada al pedido seleccionado,
      // en caso de no tener reservas o estar reservada a otro pedido no es valida.
      const infoUL = await this.GETInfoPickingUL(newPaleRead.Id);
      if (this.conPedido) {
        if (infoUL.Reservas == null || infoUL.Reservas.length === 0) {
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.noReservation'));
          return false;
        }

        if (infoUL.Reservas) {
          const reservaOtroPedido = infoUL.Reservas.find((r) => r.LineaPedidoVenta != null
            && r.LineaPedidoVenta.PedidoVenta != null
            && r.LineaPedidoVenta.PedidoVenta.Id !== this.selectedOrderLine.LineaPedidoVenta.PedidoVenta.Id);
          if (reservaOtroPedido != null) {
            HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.reservationInOtherOrder', {
              serial: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Serie,
              number: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Numero,
            }));
            return false;
          }
        }
      }
      return true;
    },
    async ValidateUsePaleInMerchandise(newPaleRead) {
      Log(this, this.ValidateUsePaleInMerchandise.name);
      if (this.mainData.Base != null && this.mainData.Base.NumeroSerie === newPaleRead.NumeroSerie) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.palletAsBase'));
        return false;
      } if (this.mainData.Base != null && this.mainData.Base.UnidadContenedora != null && newPaleRead.NumeroSerie === this.mainData.Base.UnidadContenedora.NumeroSerie) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.palletAsBase'));
        return false;
      } if (this.mainData.Mercancia.filter((m) => m.NumeroSerie === newPaleRead.NumeroSerie).length > 0) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.palletAsMerchandise'));
        return false;
      }
      PreloaderGH(true, true, this.$t('commercialization.info.validatingPallet'), '');
      const infoUL = await this.GETInfoPickingUL(newPaleRead.Id);
      PreloaderGH(false);
      if (infoUL.Reservas != null && infoUL.Reservas.length > 0) {
        const reservaOtroPedido = infoUL.Reservas.find((r) => r.LineaPedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta.Id !== this.selectedOrderLine.LineaPedidoVenta.PedidoVenta.Id);
        if (reservaOtroPedido != null) {
          newPaleRead.LineaPedidoVentaOrigen = reservaOtroPedido.LineaPedidoVenta;

          const result = await new Promise((resolve) => {
            this.$refs.UCConfirmationReprocessed.create(
              this.$t('commercialization.picking.palletizing.info.reservationInOtherOrderConfirm.title'),
              this.$t('commercialization.picking.palletizing.info.reservationInOtherOrderConfirm.text', {
                serial: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Serie,
                number: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Numero,
              }),
              async () => {
                if (
                  this.mantenerReservaPaleOrigenTraspasoMovilidad
                  || this.replanificarCantidadPaleTraspasadoOReprocesado
                ) {
                  return resolve(true);
                }

                const resultRemoveReservation = await this.RemoveReservationPale(infoUL, false);
                return resolve(resultRemoveReservation);
              },
              () => {
                resolve(false);
              },
            );
            this.$refs.UCConfirmationReprocessed.show();
          });
          return result;
        }
        const reservaMismoPedido = infoUL.Reservas.find((r) => r.LineaPedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta.Id === this.selectedOrderLine.LineaPedidoVenta.PedidoVenta.Id);
        if (reservaMismoPedido != null) {
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.reservationInSameOrder'));
          return false;
        }
      }
      return true;
    },
    async RemoveReservationPale(info, restoreMerchandiseToOrigin) {
      Log(this, this.RemoveReservationPale.name);

      PreloaderGH(true, true, this.$t('commercialization.picking.palletizing.removeReservation.preloaderText'), '');
      try {
        const result = await this.SENDDeleteReservation([{ Reserva: { Id: 0 }, UnidadContenedoraOrigenTraspaso: null, UnidadContenedora: info.UnidadLogistica }], restoreMerchandiseToOrigin);
        PreloaderGH(false);
        if (!result) {
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.removeReservation.error'));
          return false;
        }
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.removeReservation.success'));
        return true;
      } catch (error) {
        LogError(this, this.RemoveReservationPale.name, error);
        PreloaderGH(false);
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.removeReservation.error'));
        return false;
      }
    },
    ConfirmTypePackagingReprocessed(newPackagingReprocessed) {
      Log(this, this.ConfirmTypePackagingReprocessed.name);
      this.mainData.ConfeccionReprocesado = newPackagingReprocessed;
    },
    ConfirmNewDataForNewPale(newDataForNewPale) {
      Log(this, this.ConfirmNewDataForNewPale.name);
      this.mainData.InfoNuevoPale = newDataForNewPale;
    },
    ConfirmScanData(value) {
      Log(this, this.ConfirmScanData.name);
      this.ProcessPaleRead(value);
    },
    GetContainerFromPale(objPale) {
      Log(this, this.GetContainerFromPale.name);
      const tempAcumuladosEnvase = objPale.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase');
      if (tempAcumuladosEnvase.length > 1) {
        return `${tempAcumuladosEnvase[0].Articulo.Nombre} (+)`;
      }
      return tempAcumuladosEnvase[0].Articulo.Nombre;
    },
    DeletePaleSelection(val) {
      for (let i = 0; i < this.mainData.Mercancia.length; i += 1) {
        const element = this.mainData.Mercancia[i];
        if (val.NumeroSerie === element.NumeroSerie) {
          this.mainData.Mercancia.splice(i, 1);
        }
      }
    },

    async GETInfoPickingUL(idPale) {
      const result = await ConexionTA.callConsultarEstadoULParaUsoPicking(idPale);
      if (result.Valor) {
        const lstEstadoUnidadLogisticaPicking = JSON.parse(result.Mensaje);
        if (lstEstadoUnidadLogisticaPicking != null && lstEstadoUnidadLogisticaPicking.length > 0) {
          return lstEstadoUnidadLogisticaPicking[0];
        }
      }
      return false;
    },
    async SENDDeleteReservation(lstReservations, restoreMerchandiseToOrigin) {
      Log(this, this.SENDDeleteReservation.name);
      const result = await ConexionTA.callEliminarReservaDePaleLineaPedidoParaPicking(lstReservations, restoreMerchandiseToOrigin);
      return result.Valor;
    },
  },
};
</script>

<style scoped lang="scss">
.print {
  margin-top: -20px;
}

.qr {
  width: 100%;
  height: 100%;
  margin-left: -25px;
}

.pletizado__cabecera {
  margin: 0;
  background: #ebecf0;
}

.text-1 {
  color: var(--his-steel-blue);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.05px;
}

.text-2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin: auto;
  color: var(--his-oliva);
  mix-blend-mode: normal;
}

.palets {
  min-height: 200px;
}

.paletizado__footer {
  background: #ebecf0;
  width: 100%;
  margin: 0;
  padding: 10px;
  padding-top: 25px;
}

.new-palet-btn {
  width: 146px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.85px;
  color: #fff;
  background: var(--his-mandarina);
  border-radius: 6px;
}

.cancel-btn {
  width: 146px;
  background: #ebecf0;
  color: var(--his-metal);
  text-align: center;
}

.confirm-btn {
  width: 146px;
  height: 27;
  text-align: center;
  color: #fff;
  background: var(--his-greendark);
  border-radius: 6px;
}

// estilos palet
.containerp {
  border-top: 1px solid #ebecf0;
  height: 180px;
  overflow-y: auto;
  margin: 0;
}

.row-palet {
  background: #fff;
  padding: 10px;
  border-top: 1px solid #ebecf0;
}

.btn-popup {
  width: 100%;
  height: 100%;
  margin: auto;
}

.text-1-palet {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: var(--his-steel-blue);
}

.text-2-palet {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  margin-top: 4px;
  color: var(--his-steel-blue);
}

.text-3-palet {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: var(--his-oliva);
}

.container__palet--sub-id {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--his-oliva);
}

// estilos popup añadir nuevo palet gestion reserva o editar palet

.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.col-reproces-btn {
  display: flex;
}

.btn {
  margin: 5px;
}
</style>
